import { defineComponent as _defineComponent } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
import { getAuth } from 'firebase/auth'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import store from '@/store'


export default /*#__PURE__*/_defineComponent({
  __name: 'LogOut',
  setup(__props) {

const route = useRoute()
const router = useRouter()

function logout() {
  getAuth().signOut()
  store.dispatch('setUserDB', null)
  store.dispatch('setUserFB', null)
  localStorage.removeItem('currentProfileId')
  router.push({
    name: 'Login',
    query: { redirect: route.path },
  })
}

return { __sfc: true,route, router, logout }
}

})